import { Link } from "react-router";
import { useExperience } from "../hooks/useExperience";
import Logo from "./Logo";
import { Icon } from "./Icons";

export default function Footer() {
  const { paused, reducedMotion, staticMode, toggleMotion, toggleStatic } =
    useExperience();
  return (
    <footer className="site-footer">
      <Link className="wordmark" to="/" aria-label="Darren | home">
        <Logo />
      </Link>
      <span className="mono">
        © {new Date().getFullYear()} Darren
        <br />
        Built by Darren in Colorado.
      </span>
      <div className="footer-controls">
        <button
          onClick={toggleMotion}
          disabled={reducedMotion}
          aria-pressed={paused || reducedMotion}
        >
          {reducedMotion
            ? "Reduced motion respected"
            : paused
              ? "Motion paused"
              : "Pause motion"}
        </button>
        <button onClick={toggleStatic} aria-pressed={staticMode}>
          {staticMode ? "Static visuals on" : "Use static visuals"}
        </button>
      </div>
      <nav className="footer-legal" aria-label="Legal">
        <Link to="/privacy">Privacy</Link>
        <Link to="/terms">Terms</Link>
      </nav>
      <a className="back-top mono" href="#main">
        Back to top <Icon name="up" />
      </a>
    </footer>
  );
}
